import React from 'react';
import PropTypes from 'prop-types';
import TravelImg from 'products/nomad_insurance/assets/img/claims/travel-turquoise.svg';
import MedicalImg from 'products/nomad_insurance/assets/img/claims/medical-turquoise.svg';
import { TravelIcon } from './styled';
import { CLAIM_TYPES } from '../../../../consts';

const ClaimTypeIcon = ({ claimType }) => {
  const src = claimType === CLAIM_TYPES.TRAVEL ? TravelImg : MedicalImg;
  return <TravelIcon src={src} alt={`${claimType} claim`} />;
};

ClaimTypeIcon.propTypes = {
  claimType: PropTypes.string
};

export default ClaimTypeIcon;
